import React from 'react';
import { IndicatorConfig, Sales } from '../../types';
import styles from './InformationBlock.module.css';
import { AccountIndicatorsBlock } from './AccountIndicatorsBlock';
import { useTranslation } from '../../../../../../hooks';

export const AccountIndicatorsLine = ({
  items,
  sales,
}: {
  items: IndicatorConfig[];
  sales: Sales;
}) => {
  const { t } = useTranslation();
  return (
    <div className={styles.accountIndicatorsLine}>
      {items.map((item, idx) => {
        return (
          <React.Fragment key={idx}>
            <AccountIndicatorsBlock
              label={t(item.label)}
              value={sales[item.key]}
              format={item.format}
              suffix={item.suffix}
            />
            {idx < items.length - 1 && <div className={styles.separate}> </div>}
          </React.Fragment>
        );
      })}
    </div>
  );
};
